import Carousel from './carousel';

const targetElem = '.get-involved-widget-slider';
const sliderSettings = {
    mobileFirst: true,
    arrows: true,
    dots: true,
    centermode: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                dots: true
            }
        }
    ]
};

const carousel = new Carousel(targetElem, sliderSettings);
carousel.init();